import { getStorage } from "@/utils/storage";
const user = {
  namespaced: true, // 添加 namespaced 属性
  state: {
    city_label: "",
    city_value: "",
    download_state: false,
  },
  mutations: {
    changeDownloadState(state, data) {
      state.download_state = data;
    },
    getPosition(state) {
      state.city_label = getStorage("selectCityLabel");
      state.city_value = getStorage("selectCityValue");
      console.log(state.city_label, state.city_value);
    },
  },
  actions: {},
  getters: {},
};

export default user;
